import { screeningsApiClient } from 'src/api/config';
import Notifier from 'common/helpers/Notifier';
import { isHttpSuccess } from 'src/api/utils/httpStatus';

async function bulkAssignScreens(assignedScreenIds) {
  try {
    const response = await screeningsApiClient.patch(
      'screenings/bulk_assign',
      { assign: assignedScreenIds },
    );

    if (!response || !isHttpSuccess(response.status)) {
      Notifier.dispatch(
        400,
        'Screening cannot be assigned',
      );
      return false;
    }

    return true;
  } catch (error) {
    Notifier.handleErrors(error);
    return false;
  }
}

export default bulkAssignScreens;
